import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createTRPCOptionsProxy } from "@trpc/tanstack-react-query";
import type { AppRouter } from "../../../api/src/trpc/routers/appRouter";
import { TRPCProvider, trpcClient } from "../lib/trpc";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            staleTime: 1000 * 60, // Always fetch fresh data after 1 minute
            gcTime: 1000 * 60,
            refetchOnWindowFocus: false,
        },
    },
});

export const trpc = createTRPCOptionsProxy<AppRouter>({
    client: trpcClient,
    queryClient: queryClient,
});

export default function QueryProvider({ children }: { children: any }) {
    return (
        <QueryClientProvider client={queryClient}>
            <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
                {/* Your app here */}
                {children}
            </TRPCProvider>
        </QueryClientProvider>
    );
}
